import * as Blockly from 'blockly/core';
import { BoardType } from '@/(routers)/boards/editor/block/blockConfig';
import { defineBlock } from '@/(routers)/boards/editor/block/blockRegistry';
import { CATEGORIES } from '@/(routers)/boards/editor/block/definitions/categories';
import { FieldStyledLabel } from '@/(routers)/boards/editor/block/definitions/fields/fieldStyledLabel';

defineBlock({
    type: 'analog_max',
    colour: CATEGORIES.operator.color,
    tooltip: 'アナログ値の最大値（オレンジ: 1023 / ブルー: 4095）',
    movable: true,
    deletable: true,
    inline: true,
    output: 'Number',
    inputs: [
        {
            kind: 'dummy',
            fields: [
                {
                    type: 'field',
                    instance: () =>
                        new FieldStyledLabel('アナログ値の最大', {
                            fontSize: 12,
                            fontWeight: 'bold',
                        }),
                },
                { type: 'label', text: ' ' },
            ],
        },
        {
            kind: 'dummy',
            fields: [
                {
                    type: 'field',
                    name: 'DISPLAY',
                    instance: () => new FieldStyledLabel('1023', { fontSize: 12, numberStyle: true }),
                },
            ],
        },
    ],
    onBoardChange(block: Blockly.Block, board: BoardType) {
        const value = board === 'blue' ? '4095' : '1023';
        block.getField('DISPLAY')?.setValue(value);
        (block as Blockly.BlockSvg).render();
    },
    onInit(this: Blockly.Block) {
        setTimeout(() => {
            const { useBoardEditorStore } = require('@/stores/useBoardEditorStore');
            const board = useBoardEditorStore.getState().board;
            const value = board === 'blue' ? '4095' : '1023';
            this.getField('DISPLAY')?.setValue(value);
            (this as Blockly.BlockSvg).render();
        }, 0);
    },
});
